import { IdValue } from '../../../shared/models/id-value.model';

export enum DemographicInfoProvidedMethod {
  NotAssigned = 0,
  FaceToFace = 1,
  Telephone = 2,
  FaxOrMail = 3,
  EmailOrInternet = 4,
}

export const infoProvidedViaOptions = [
  new IdValue(0, DemographicInfoProvidedMethod.NotAssigned, 'Select'),
  new IdValue(1, DemographicInfoProvidedMethod.FaceToFace, 'Face To Face (includes Electronic Media w/ Video Component)'),
  new IdValue(2, DemographicInfoProvidedMethod.FaxOrMail, 'Fax or Mail'),
  new IdValue(3, DemographicInfoProvidedMethod.Telephone, 'Telephone'),
  new IdValue(4, DemographicInfoProvidedMethod.EmailOrInternet, 'Email or Internet'),
];

export const completedDropdownOptions = [
  new IdValue(0, 0, 'Select'),
  new IdValue(1, 1, 'Provided by Borrower'),
  new IdValue(2, 2, 'Not Provided in Mail, Telephone, or Internet Application'),
  new IdValue(3, 3, 'Collected on the Basis of Visual Observation or Surname'),
];
